let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("6s9LC")).then(() => parcelRequire('k4e6D'));